// src/components/GameOver.js
import React from 'react';

const GameOver = ({ onRestart }) => {
  return (
    <div className="game-over">
      <h1>Game Over</h1>
      <button onClick={onRestart}>Comenzar de nuevo</button>
    </div>
  );
};

export default GameOver;